import createAPIServices from './createAPIServices'

const api = createAPIServices()

// api phần user
export const searchTasks = (page_number, page_size, text, status) => {
    return api.makeAuthRequest({
        url: `/search/tasks?page_number=${page_number}&page_size=${page_size}&text=${text}&status=${status}`,
        method: 'GET',
    })
}
export const searchEvent = (page_number, page_size, text, status, begin_time = 0,
    end_time = 0,
    type_search = '') => {
    // return api.makeAuthRequest({
    //     url: `/search/events?page_number=${page_number}&page_size=${page_size}&text=${text}&status=${status}`,
    //     method: 'GET',
    // })
    return api.makeAuthRequest({
        url: `/search/events_v2`,
        method: 'POST',
        data: {
            "type_search": type_search,
            "text_search": text,
            "page_number": page_number,
            "page_size": page_size,
            "status": status,
            "begin_time": begin_time,
            "end_time": end_time

        }
    })
}
